import { render, staticRenderFns } from "./ExpandCollapse.vue?vue&type=template&id=4d6d96c9"
import script from "./ExpandCollapse.vue?vue&type=script&lang=js"
export * from "./ExpandCollapse.vue?vue&type=script&lang=js"
import style0 from "./ExpandCollapse.vue?vue&type=style&index=0&id=4d6d96c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports